import { mount } from 'svelte';
import Ready2RaceForm from '$js/modules/participate-event/templates/Ready2RaceForm.svelte';
import ClinicForm from '$js/modules/participate-event/templates/ClinicForm.svelte';

const user = window.user;
const profileUrl = window.profileUrl;

export const initParticipateEvent = () => {
  const participateForm: HTMLElement | null = document.querySelector('#js-participate-form');

  if (!participateForm) {
    return;
  }

  if (participateForm.dataset.format === 'dbr') {
    mount(Ready2RaceForm, {
      target: participateForm,
      props: {
        user,
        profileUrl,
      },
    });
  }

  if (participateForm.dataset.format === 'clinic') {
    mount(ClinicForm, {
      target: participateForm,
      props: {
        user,
        profileUrl,
      },
    });
  }
};
